import router from "@/router";
import store from "@/store";
import httpClient from "@/http/httpClient";

import _ from "lodash";
import { toast } from "@starline-security/component-library";

export default {
  namespaced: true,
  state: {
    twoFactor: false,
    twoFactorUrl: null,
    token: localStorage.getItem("token") || "",
    errorMessage: [],
    status: false,
    userRole: "",
    user: {
      email: null,
      first_name: "",
      last_name: "",
      phone: "",
      state: "",
      roles: [],
    },

    successText: false,
    resetModal: false,
    abilities: [],
    blockedMessage: null,
  },
  getters: {
    can: (state) => (abilityName) => {
      return !!state.abilities.find(
        (ability) => _.toLower(ability.name) === _.toLower(abilityName)
      );
    },
    authorizeUserRole: (state) => (role) => {
      return !!state.user.roles.find((r) =>
        ["super admin", _.lowerCase(role)].includes(_.lowerCase(r.name))
      );
    },
    authorizeUserPermission: (state) => (permission) => {
      if (permission === undefined) return true;

      const target = _.toLower(permission);
      for (const role of state.user?.roles || []) {
        for (const p of role?.permissions || []) {
          if (_.toLower(p?.name) === target) {
            return true;
          }
        }
      }

      return false;
    },
    twoFactor(state) {
      return state.twoFactor;
    },
    user(state) {
      return state.user;
    },
    roles(state) {
      return state.user?.roles ?? [];
    },

    isAuthenticated(state) {
      return !!state.token;
    },

    token(state) {
      return state.token;
    },

    errorMessage(state) {
      return state.errorMessage;
    },

    status(state) {
      return state.status;
    },

    nameUser(state) {
      return state.nameUser;
    },

    getUserRole(state) {
      return state.userRole;
    },

    successText(state) {
      return state.successText;
    },

    resetModal(state) {
      return state.resetModal;
    },

    blockedMessage(state) {
      return state.blockedMessage;
    },
  },
  mutations: {
    setAbilities: function (state, payload) {
      state.abilities = payload;
    },

    closeModal(state) {
      state.status = false;
      state.errorMessage.length = 0;
    },

    authLogout(state) {
      localStorage.removeItem("token");
      state.token = "";
    },

    isNotAuth(store, payload) {
      store.token = payload;
    },

    userRole(state, payload) {
      state.userRole = payload;
    },

    successText(state, payload) {
      state.successText = payload;
    },

    updateResetModal(state, payload) {
      state.resetModal = payload;
    },
    setCurrentUser(state, payload) {
      let user = { ...state.user };
      user.email = payload.data.email;
      user.first_name = payload.data.first_name;
      user.last_name = payload.data.last_name;
      user.phone = payload.data.phone;
      user.state = payload.data.state;
      user.roles = payload.data.roles;
      state.user = user;
    },
    setTwoFactor(state, payload) {
      state.twoFactor = payload;
    },
    setTwoFactorUrl(state, payload) {
      state.twoFactorUrl = payload;
    },
    setBlockedMessage(state, payload) {
      state.blockedMessage = payload;
    },
  },
  actions: {
    async refreshCurrentUser({ commit }) {
      try {
        const response = await httpClient.post("current-user");
        commit("setCurrentUser", response.data);
      } catch (error) {
        store.commit("errorsModal/openModal", error.response.data.errors);
      } finally {
        // store.commit("preloader/preloader", false);
      }
    },

    async login({ commit }, credential) {
      store.commit("preloader/preloader", true);

      try {
        const response = await httpClient.post("login", {
          email: credential.email,
          password: credential.password,
        });
        if (response.data.two_factor) {
          commit("setTwoFactor", true);
          commit("setTwoFactorUrl", response.data.redirect_url);
          return;
        }

        localStorage.setItem("token", response.data.token);
        location.reload();
      } catch (error) {
        const errorMsg = error?.response?.data?.message;

        if (
          errorMsg &&
          (errorMsg.toLowerCase().includes("blocked") ||
            errorMsg.toLowerCase().includes("deactivated"))
        ) {
          commit("setBlockedMessage", errorMsg);
        } else {
          toast.error(errorMsg || "Login failed");
        }
      } finally {
        store.commit("preloader/preloader", false);
      }
    },
    async login2fa({ state }, credential) {
      store.commit("preloader/preloader", true);
      try {
        const response = await httpClient.post(state.twoFactorUrl, {
          code: credential.code,
          recovery_code: credential.recoveryCode,
        });

        localStorage.setItem("token", response.data.token);
        location.reload();
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.errors?.error?.[0] ||
            "Could not authenticate"
        );
        // request.logout()
      } finally {
        store.commit("preloader/preloader", false);
      }
    },
    forgotPass(context, credential) {
      store.commit("preloader/preloader", true);
      httpClient
        .post("forget-password", {
          email: credential.email,
        })
        .then((response) => {
          if (response.status === 201 || response.status === 200) {
            // context.commit("successText", true);
            toast.success("Reset email sent!");
          }
        })
        .catch((error) => {
          localStorage.removeItem("token");
          store.commit("errorsModal/openModal", error.response.data.errors);
        })
        .finally(() => {
          store.commit("preloader/preloader", false);
        });
    },

    logout(context) {
      // request.logout();
      context.commit("authLogout");
    },

    closeModal(context) {
      context.commit("closeModal");
    },
  },
};
